module.exports = __webpack_public_path__ + "static/moneysprout--mobile-76ad979a7e19a87da0399b7f330cad97.jpg";